<template>
  <v-dialog v-model="show" persistent max-width="500px" scrollable>
    <v-card>
      <v-card-title class="modal_title">
        <div class="circle">
          <v-icon color="error">warning</v-icon>
        </div>
        <span>{{ title }}</span>
      </v-card-title>
      <v-card-text class="text">
        <p v-if="description !== ''">{{ description }}</p>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-btn primary flat @click="cancel" class="modal_button">{{
          cancelText
        }}</v-btn>
        <v-btn color="primary" @click="submit" class="modal_button">{{
          okText
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
    okText: {
      type: String,
      default: 'Guardar',
    },
  },
  methods: {
    submit() {
      this.$emit('change', true)
      this.closeModal()
    },
    cancel() {
      this.$emit('change', false)
      this.closeModal()
    },
    closeModal() {
      this.show = false
    },
  },
}
</script>

<style scoped>
/* override css */
::v-deep .v-btn__content {
  text-transform: initial !important;
}

.custom_input_title {
  font-weight: 500;
}

.modal_title {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 0px;
}

.modal_title span {
  line-height: initial;
  font-weight: 600;
  text-align: center;
  font-size: 18px;
}

.circle {
  padding: 8px 10px;
  border-radius: 100%;
  background-color: #fee2e2;
}

.modal_button {
  margin: 0;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: initial !important;
}

.modal_button:last-of-type {
  width: calc(50% - 10px);
  margin-left: 10px;
  font-size: 14px !important;
  font-weight: 500;
}

.text {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #6b7280;
}
</style>
